export default {
  api: process.env.NODE_ENV === 'production' ? '/hd' : '/hd',
  BASE_API: process.env.NODE_ENV === 'production' ? '/hd' : '/hd'
};
